import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Survey from './components/Survey';
import Results from './components/Results';
import Interviews from './components/Interviews';
import WelcomeModal from './components/WelcomeModal';

function App() {
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
  };

  return (
    <AppProvider>
      <Router>
        <WelcomeModal isOpen={showWelcomeModal} onClose={handleCloseWelcomeModal} />
        <Routes>
          <Route path="/" element={
            <Layout>
              <Dashboard />
            </Layout>
          } />
          <Route path="/survey" element={
            <Layout>
              <Survey />
            </Layout>
          } />
          <Route path="/results" element={
            <Layout>
              <Results />
            </Layout>
          } />
          <Route path="/interviews" element={
            <Layout>
              <Interviews />
            </Layout>
          } />
          <Route path="/reports" element={
            <Layout>
              <div className="p-6"><h1>Reports Page</h1><p>Coming soon...</p></div>
            </Layout>
          } />
          <Route path="/schedule" element={
            <Layout>
              <div className="p-6"><h1>Schedule Page</h1><p>Coming soon...</p></div>
            </Layout>
          } />
          <Route path="/analytics" element={
            <Layout>
              <div className="p-6"><h1>Analytics Page</h1><p>Coming soon...</p></div>
            </Layout>
          } />
          <Route path="/settings" element={
            <Layout>
              <div className="p-6"><h1>Settings Page</h1><p>Coming soon...</p></div>
            </Layout>
          } />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
